<template>
  <div class="main-container">
    <div class="login-container">
      <h1>BIBO</h1>
      <button type="button" class="btn btn-primary btn-lg" @click="signIn">Login</button>
    </div>
  </div>
</template>

<script>
import msalAuth from '../services/msalAuth';

export default {
  name: 'LoginPage',
  methods: {
    signIn() {
      msalAuth.signIn();
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.login-container {
  text-align: center;
}
</style>
